import React from 'react'
import { HeroWrapper, HeroLogosCloudWrapper, Headline } from './style'
import Container from '../../elements/container'
import { partnerLogos } from '../../../cdn_images/campaign'
import SectionLogosBase from '../../section_logos_base'

const Hero = ({ children, showLogos }: any) => {
  return (
    <>
      <HeroWrapper>
        <Container>
          {children}
          <HeroLogosCloudWrapper>
            {/* <Headline>{RichText.render(logosHeadline)}</Headline> */}
            {/* Logos cloud */}
            {showLogos && <SectionLogosBase items={partnerLogos} />}
          </HeroLogosCloudWrapper>
        </Container>
      </HeroWrapper>
    </>
  )
}

export default Hero
